import React, { Component, Fragment } from 'react';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import FooterLinkIdentifiers from './../../../../../constants/FooterLinkIdentifiers.js';
import style from './style/aboutreport.scss';

export default class AboutReportAttachment extends Component {
    render() {
        const { i18nParticipation } = this.props;

        return <Fragment>
            <div className={ style.report_page_container }>
                <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                    { i18nParticipation.report_more_information }
                </SectionBlock>
                <div className={style.report_page_content_wrapper}>
                    <div className={ style.report_page_section_wrapper }>
                        <h3 id={FooterLinkIdentifiers.REPORT_ABOUT_THIS_REPORT}>{ i18nParticipation.report_about_this_report }</h3>
                        <p>{ i18nParticipation.report_about_this_report_default_text }</p>
                    </div>
                    <div className={ style.report_page_section_wrapper }>
                        <h3 id={FooterLinkIdentifiers.REPORT_VALIDITY}>{ i18nParticipation.report_validity }</h3>
                        <p>{ i18nParticipation.report_validity_default_text }</p>
                    </div>
                    <div className={ style.report_page_section_wrapper }>
                        <h3 id={FooterLinkIdentifiers.REPORT_DISCLAIMER}>{ i18nParticipation.report_disclaimer }</h3>
                        <p>{ i18nParticipation.report_disclaimer_default_text }</p>
                    </div>
                </div>
            </div>
        </Fragment>;
    }
}
